import XLSX from "xlsx";
/**
 * 导出一个自定义表头的 worksheet
 * @param {*} data 表格数据（json数组）
 * @param {*} tableName 导出的表名字  例: xxx.xlsx
 * @param {*} titles 表头映射（选填） 例： {name:"姓名"，age:"年龄"}
 */
const downLoadWrokSheet = (data, tableName, titles) => {
  let ws = null;
  if (titles) {
    let myData = JSON.parse(JSON.stringify(data));
    let formateDataList = [];
    //格式化数据
    myData.forEach(item => {
      let newItem = {};
      for (let [key, colName] of Object.entries(titles)) {
        newItem[colName] = item[key]
      }
      formateDataList.push(newItem);
    });
    ws = XLSX.utils.json_to_sheet(formateDataList, {
      header: Object.values(titles)
    });
  } else {
    ws = XLSX.utils.json_to_sheet(data);
  }

  //格式化数据类型
  _formatDataType(ws)

  // 新建一个工作簿
  const workbook = XLSX.utils.book_new();
  /* 将工作表添加到工作簿*/
  XLSX.utils.book_append_sheet(workbook, ws, "Sheet1");
  /* 输出工作表， 由文件名决定的输出格式*/
  XLSX.writeFile(workbook, tableName);
}

const _formatDataType = (ws) => {
  for (let [cellNum, cellConf] of Object.entries(ws)) {
    if (!/^!/g.test(cellNum) && !/[A-Z]1$/g.test(cellNum)) {  //除开“!”开头的特殊属性和表头属性
      if (/%$/g.test(cellConf.v) && !isNaN(Number(cellConf.v.replace("%", "")))) {  //%结尾的数字
        let lastLength = cellConf.v.replace("%", "").split(".")[1];
        let accuracy = lastLength ? lastLength.length : 0; //百分比小数位数
        cellConf.t = "n";
        cellConf.v = Number(cellConf.v.replace("%", "")) / 100;
        switch (accuracy) {
          case 0:
            cellConf.z = "0%";
            break;
          case 1:
            cellConf.z = "0.0%";
            break;
          case 2:
            cellConf.z = "0.00%";
            break;
          default:
            cellConf.z = "0.000%";
            break;
        }
      } else if (String(cellConf.v).length <= 12 && !isNaN(Number(String(cellConf.v)))) {  //数字字符串
        cellConf.t = "n";
        cellConf.v = Number(cellConf.v);
      }
    }
  }
}

export {
  downLoadWrokSheet
}